import firebase from "firebase/compat/app";

export const AUTH_CONFIG = {
  apiKey: process.env.REACT_APP_AUTH_API_KEY || "",
  authDomain: process.env.REACT_APP_AUTH_API_DOMAIN || "",
  projectId: process.env.REACT_APP_PROJECT_ID || "",
};

export const auth_app = firebase.initializeApp(AUTH_CONFIG);
